module.exports = __webpack_public_path__ + "static/media/daniella_wenger.5d407259.jpeg";